import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function ItemUnit ( props ) {

    return <BasicCrudScreenType id="ItemUnit" table="ItemUnit" view="VwItemUnit" />;

}

export default ItemUnit;
